import { Fragment } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { IonIcon, IonButton, IonBadge } from "@ionic/react";

import "./NavBarItem.css";

interface NavBarItemProps extends RouteComponentProps<any> {
  path?: string;
  label?: string;
  title?: string;
  iconOff?: string;
  iconOn?: string;
  badgeValue?: number;
  onClick?: () => void;
  cssClass?: string;
}

// eslint-disable-next-line react-refresh/only-export-components
const NavBarItem: React.FC<NavBarItemProps> = ({
  match,
  path,
  label,
  title,
  iconOff,
  iconOn,
  badgeValue,
  onClick,
  cssClass,
}) => {
  return (
    <Fragment>
      <div className="navbar-item-container">
        <IonButton
          className={
            "navbar-item " +
            (cssClass ? cssClass : "") +
            (path && match.url.includes(path) ? " navbar-item-active" : "")
          }
          routerLink={path ? path : undefined}
          onClick={onClick ? onClick : undefined}
          title={title}
        >
          {badgeValue! > 0 && (
            <IonBadge className="navbar-item-badge" color="danger">
              {badgeValue}
            </IonBadge>
          )}
          <IonIcon  icon={path && match.url.includes(path) ? iconOn : iconOff} />
          {label && <div className="navbar-label">{label}</div>}
        </IonButton>
        {label && <div className="navbar-label below-icon">{label}</div>}
      </div>
      {/* <div className="navbar-item-indicator"></div> */}
    </Fragment>
  );
};

export default withRouter(NavBarItem);
